"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Spotlight = /*#__PURE__*/function (_Component) {
  function Spotlight(props) {
    var _this;
    _classCallCheck(this, Spotlight);
    _this = _callSuper(this, Spotlight, [props]);
    _this.state = {
      visible: false,
      target: null,
      rectangles: {
        left: {
          width: null,
          height: null,
          top: null,
          left: null
        },
        top: {
          width: "100%",
          height: null,
          top: null,
          left: null
        },
        right: {
          width: null,
          height: null,
          top: null,
          left: null
        },
        bottom: {
          width: "100%",
          height: null,
          top: null,
          left: null
        }
      },
      opacity: 0
    };
    _this.onScroll = _this.onScroll.bind(_this);
    _this.getPadding = _this.getPadding.bind(_this);
    _this.getContext = _this.getContext.bind(_this);
    _this.fadeOutTimeout = null;
    return _this;
  }
  _inherits(Spotlight, _Component);
  return _createClass(Spotlight, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.getContext().removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (this.state.visible === true && this.state.target !== null && (prevState.visible === false || prevState.opacity < this.props.maxOpacity)) {
        clearTimeout(this.fadeOutTimeout);
        setTimeout(function () {
          _this2.setState({
            opacity: _this2.props.maxOpacity
          });
        }, 10);
      } else if (this.state.opacity === 0 && prevState.opacity > 0 && this.state.visible === true) {
        this.fadeOutTimeout = setTimeout(function () {
          _this2.setState({
            visible: false
          });
        }, this.props.fadeTime);
      }
    }
  }, {
    key: "show",
    value: function show(target) {
      this.setState({
        visible: true,
        target: target
      });
      this.getContext().addEventListener('scroll', this.onScroll);
      this.setRectanglesSize(target);
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (this.state.target !== null) {
        this.setRectanglesSize(this.state.target);
      }
    }
  }, {
    key: "setRectanglesSize",
    value: function setRectanglesSize(target) {
      var boundingClientRect = target.getBoundingClientRect();
      var windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var leftWidth = boundingClientRect.left - this.getPadding('horizontal');
      var left = {
        width: "".concat(leftWidth > 0 ? leftWidth : 0, "px"),
        height: "".concat(boundingClientRect.height + this.getPadding('vertical') * 2, "px"),
        top: "".concat(boundingClientRect.top - this.getPadding('vertical'), "px"),
        left: "0px"
      };
      var topHeight = boundingClientRect.top - this.getPadding('vertical');
      var top = {
        width: "100%",
        height: "".concat(topHeight > 0 ? topHeight : 0, "px"),
        top: "0px",
        left: "0px"
      };
      var rightWidth = windowWidth - boundingClientRect.right - this.getPadding('horizontal');
      var right = {
        width: "".concat(rightWidth, "px"),
        height: "".concat(boundingClientRect.height + this.getPadding('horizontal') * 2, "px"),
        top: "".concat(boundingClientRect.top - this.getPadding('vertical'), "px"),
        right: "0px"
      };
      var bottomHeight = windowHeight - boundingClientRect.bottom - this.getPadding('vertical');
      var bottom = {
        width: "100%",
        height: "".concat(bottomHeight > 0 ? bottomHeight : 0, "px"),
        bottom: "0px",
        left: "0px"
      };
      this.setState({
        rectangles: {
          left: left,
          top: top,
          right: right,
          bottom: bottom
        }
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        opacity: 0,
        target: null
      });
      this.getContext().removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "getContext",
    value: function getContext() {
      var context = window;
      if (this.props.context) {
        if (this.props.context.indexOf('.') === 0) {
          context = document.getElementsByClassName(this.props.context.substr(1))[0];
        } else if (this.props.context.indexOf('#') === 0) {
          context = document.getElementById(this.props.context.substr(1));
        } else {
          context = window;
        }
      }
      if (!context) {
        console.warn("The context set on the spotlight wasn't found. Defaulted to window");
        context = window;
      }
      return context;
    }
  }, {
    key: "getBasicStyles",
    value: function getBasicStyles() {
      return {
        position: "fixed",
        zIndex: "9998",
        backgroundColor: this.props.backgroundColor,
        transition: this.props.fade ? "opacity ".concat(this.props.fadeTime, "ms") : null,
        opacity: "".concat(this.state.opacity)
      };
    }
  }, {
    key: "getPadding",
    value: function getPadding(position) {
      if (_typeof(this.props.padding) === 'object') {
        if (position === "horizontal") {
          return this.props.padding[1];
        } else {
          return this.props.padding[0];
        }
      }
      return this.props.padding;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.visible === true) {
        return [/*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightLeft",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.left)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightTop",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.top)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightRight",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.right)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightBottom",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.bottom)
        })];
      } else {
        return null;
      }
    }
  }]);
}(_react.Component);
Spotlight.propTypes = {
  backgroundColor: _propTypes["default"].string,
  maxOpacity: _propTypes["default"].number,
  fade: _propTypes["default"].bool,
  fadeTime: _propTypes["default"].number,
  padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
  context: _propTypes["default"].string
};
Spotlight.defaultProps = {
  backgroundColor: "#000",
  maxOpacity: 0.8,
  fade: true,
  fadeTime: 600,
  padding: 6
};
var _default = exports["default"] = Spotlight;